export const iconFontAwesomeHumanitarianHospital = (
	<i className="fa-solid fa-hospital"></i>
);
